// extracted by mini-css-extract-plugin
export default {"customRows":"SwitchCompany_customRows__oX4rE"};